export function appDataReducerBreadcrumbs(state, action) {
    const breadcrumbsData = action.breadcrumbs;

    const breadcrumbs = {
        company: {
            id: typeof breadcrumbsData.company.id != 'undefined' ? breadcrumbsData.company.id : '',
            name: typeof breadcrumbsData.company.name != 'undefined' ? breadcrumbsData.company.name : '',
            debtorNumber: typeof breadcrumbsData.company.debtorNumber != 'undefined' ? breadcrumbsData.company.debtorNumber : '',
        },
        license: {
            id: typeof breadcrumbsData.license.id != 'undefined' ? breadcrumbsData.license.id : '',
            description:
                typeof breadcrumbsData.license.description != 'undefined' ? breadcrumbsData.license.description : '',
        },
        administration: {
            id: typeof breadcrumbsData.administration.id != 'undefined' ? breadcrumbsData.administration.id : '',
            name: typeof breadcrumbsData.administration.name != 'undefined' ? breadcrumbsData.administration.name : '',
        },
        apiUser: {
            id: typeof breadcrumbsData.apiUser.id != 'undefined' ? breadcrumbsData.apiUser.id : '',
            name: typeof breadcrumbsData.apiUser.name != 'undefined' ? breadcrumbsData.apiUser.name : '',
        },
    };

    return breadcrumbs;
}
